import { ComponentChildren, ComponentProps } from 'preact';
import { Separator } from '../UNSAFE_Separator';
import { MobileDropdown } from './MobileDropdown';
import { selectMobileDropdownStyles } from './themes/selectMobileDropdownStyles.css';

type MobileDropdownProps = ComponentProps<typeof MobileDropdown>;
type PassThroughMobileDropdownProps = Pick<MobileDropdownProps, 'id' | 'isOpen'>;

type Props = PassThroughMobileDropdownProps & {
  /**
   * The main dropdown content
   */
  children?: ComponentChildren;

  /**
   * The components to be placed in the end of the dropdown
   */
  footer?: ComponentChildren;

  /**
   * The components to be placed in the beginning of the dropdown
   */
  header?: ComponentChildren;

  /**
   * Specifies whether to have a separator between header and content
   */
  hasHeaderSeparator?: boolean;

  /**
   * Id of the label for the filter field.
   */
  labelId?: string;
};

export function SelectMobileDropdown({
  children,
  footer,
  hasHeaderSeparator = true,
  header,
  id,
  isOpen,
  labelId
}: Props) {
  return (
    <MobileDropdown id={id} isOpen={isOpen} aria-labelledby={labelId}>
      {header}
      {hasHeaderSeparator && <Separator />}
      {/* TODO: Add overflow support to View and use it here */}
      {/*  */}
      <div class={selectMobileDropdownStyles.content}>{children}</div>
      <Separator />
      {footer}
    </MobileDropdown>
  );
}
